'use client';

import { useEffect, useState } from 'react';
import { API_URL } from '@/utils/constants';
import { setCookie, getCookie } from 'cookies-next';
import { useRouter } from 'next/navigation';
import { Button, Notification } from '@/components/common';
import { Typography } from '../Typography';
import { Loader } from 'lucide-react';

const SalesforceSuccess = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const router = useRouter();

  useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const sfToken = urlParams.get('sf_access_token');
      const sfRefreshToken = urlParams.get('sf_refresh_token');

      if (!sfToken || !sfRefreshToken) {
        console.error('Salesforce access token not found in the URL.');
        Notification('Salesforce access token not found in the URL', 'error');

        setIsLoading(false);
        return;
      }

      try {
        const token = getCookie('token');
        const response = await fetch(
          `${API_URL}/user/save_salesforce_token?sf_access_token=${encodeURIComponent(sfToken)}&sf_refresh_token=${encodeURIComponent(sfRefreshToken)}`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (!response.ok) {
          console.log('Something went wrong');
          Notification('Something Went Wrong', 'error');
          return;
        }

        const data = await response.json();

        if (data?.data?.sf_token) {
          setCookie('salesforce', data?.data?.sf_token);
          Notification('Salesforce log in successful', 'success');
          router.push('/profile');
        } else {
          Notification('Something Went Wrong', 'error');
        }
      } catch (error) {
        console.error('Error saving Salesforce token:', error);
        Notification('Salesforce login failed!', 'error');
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);
  return (
    <div className="grid h-full items-center justify-items-center p-[10%]">
      <div className="flex w-full flex-col items-center space-y-4">
        <div className="flex justify-center">
          <img
            src="/assets/amarco.png"
            className="w-3/4 bg-cover 2xl:px-7 2xl:py-2"
          />
        </div>
        <Typography.LabelMediumExtraSmall className="w-4/2 p-[5%] py-8 text-center text-sm font-bold leading-6 text-white md:text-sm">
          Log in to CrescentGPT here.
        </Typography.LabelMediumExtraSmall>
        <div>
          <Button
            className="text-xs font-light text-black md:px-[2.2rem] 2xl:py-6"
            isDisabled={true}
          >
            {isLoading ? (
              <Loader className="mx-20 animate-spin" />
            ) : (
              <>
                <img
                  src="/assets/salesforce-logo.png"
                  className="w-5 lg:text-sm"
                />
                Sign in with Salesforce
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export { SalesforceSuccess };
